import { get, post, patch, del } from './client.js';

const base = (orgId) => `/orgs/${orgId}/workspace-templates`;

const toQS = (p) => {
  const q = Object.entries(p)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return q ? `?${q}` : '';
};

export const list    = (orgId, params = {}) => get(`${base(orgId)}${toQS(params)}`);
export const stats   = (orgId)              => get(`${base(orgId)}/stats`);
export const getById = (orgId, id)          => get(`${base(orgId)}/${id}`);
export const create  = (orgId, body)        => post(base(orgId), body);
export const update  = (orgId, id, body)    => patch(`${base(orgId)}/${id}`, body);
export const remove  = (orgId, id)          => del(`${base(orgId)}/${id}`);

export const setDefault  = (orgId, id) => post(`${base(orgId)}/${id}/set-default`, {});
export const archive     = (orgId, id) => post(`${base(orgId)}/${id}/archive`, {});
export const duplicate   = (orgId, id, body) => post(`${base(orgId)}/${id}/duplicate`, body);
